<template lang="pug">
  div.legend__group
    div(
      :class="className"
    )
      div.legend__name.semibold {{$translate('ФККО')}}
    .legend__small-group
      .search-block
        input.search-block__input.input(
          type="search"
          placeholder="Наименование"
          v-model="query"
          v-debounce:300="searchList"
        )
    ul.search-block__list.reset-list(
      v-if="list.length"
    )
      li.search-block__item.type(
        v-for="item in list" :key="'list'+item.id"
      )
        .custom-checkbox
          input.visually-hidden.custom-checkbox__input(type="checkbox" :id="'checkbox-fkko-' + item.code" @change="(event) => checkItem(event, item)" v-model="item.checked")
          label.legend__label.custom-checkbox__label(:for="'checkbox-fkko-' + item.code" )
            span.custom-checkbox__block
            span
              span.code Код ФККО: {{item.code}}
              br
              span {{item.name}}
    ul.search-block__list.search-block__list_checked.reset-list(
      v-if="checkedList.length"
    )
      li.search-block__item(
        v-for="item in checkedList" :key="'checked-'+item.id"
      )
        span.code Код ФККО: {{item.code}}
        br
        span {{item.name}}
        button.search-block__delete(
          @click="() => deleteFromList(item.id)"
        )
</template>

<script>
import { cadastr } from '@/api/api-endpoints'
import SearchMapMixin from '@/mixins/search-map-mixin'

const PER_PAGE = 10

export default {
  name: 'map-fkko',
  mixins: [SearchMapMixin],
  props: {
    className: {
      type: String,
      default: 'legend__type legend__type_with-small',
    },
  },
  data: () => ({
    query: '',
    list: [],
    checkedList: [],
  }),
  methods: {
    getEndpoint(query) {
      return cadastr.fkko({
        query: { q: query, 'per-page': PER_PAGE },
      })
    },
  },
}
</script>

<style scoped lang="scss">
.code {
  margin-bottom: 10px;
  font-size: 12px;
  color: #8b93a5;
}
</style>
